import type { AnchorHTMLAttributes, ReactNode } from "react";

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children: ReactNode;
    to: string;
}

export const Link = ({ children, to, ...props }: LinkProps) => {
    return (
        <a href={to} {...props} className="hover:underline">
            {children}
        </a>
    );
};
